import { data } from '../../svg/Labs/data';
import { makeIcon } from '../makeIcon';

export const Labs = makeIcon(data, 'labs', 'Labs');

export default Labs;
